import errorHandlers from '@/services/error-handlers';
import { mapGetters } from 'vuex';



export default {
  data() {
    return {
      isSigningIn: false
    };
  },

  computed: {
    ...mapGetters('session', ['currentUser'])
  },

  methods: {
    async signInWithThirdPartyToken(options) {
      this.isSigningIn = true;

      const { error } = await this.$store.dispatch('session/signIn', options.credentials);

      if (error) {
        errorHandlers.generic(error);
      }
      else {
        this.$closeModal('signIn');

        this.$closeModal('createAccount');

        this.detectMissingAccountInfo();
      }

      this.isSigningIn = false;
    },

    detectMissingAccountInfo() {
      if (!this.currentUser.primarySmsNumber) {
        this.$openModal('collectAccountInfo');
      }
    }
  }
};

